module.exports = __webpack_public_path__ + "img/canadian.8571b099.jpg";